import { fileTypeOf } from "./fileTypes";

/**
 * The folded-corner document glyph from the Documents module: a coloured page
 * with a lighter folded corner and the file type set in white across it.
 *
 * @param {Object} props
 * @param {Object} props.file Document the glyph describes.
 * @param {Number} props.size Rendered square size in px.
 */
const FileGlyph = ({ file, size = 20 }) => {
  const { label, color, fold } = fileTypeOf(file);

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      style={{ flex: "none", display: "block" }}
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M4.5 4a3 3 0 0 1 3-3h7L21 7.5V20a3 3 0 0 1-3 3H7.5a3 3 0 0 1-3-3z"
        fill={color}
      />
      <path d="M14.5 1L21 7.5h-5a1.5 1.5 0 0 1-1.5-1.5z" fill={fold} />
      <text
        x="12.7"
        y="17.3"
        textAnchor="middle"
        fontSize="6.1"
        fontWeight="800"
        fill="#fff"
        fontFamily="Inter,-apple-system,sans-serif"
        letterSpacing=".25"
      >
        {label}
      </text>
    </svg>
  );
};

export default FileGlyph;
